import { render } from "./PreActionConnected.vue?vue&type=template&id=54341ce9&scoped=true"
import script from "./PreActionConnected.vue?vue&type=script&lang=js"
export * from "./PreActionConnected.vue?vue&type=script&lang=js"

import "./PreActionConnected.vue?vue&type=style&index=0&id=54341ce9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54341ce9"]])

export default __exports__